import { useContext, useEffect, useState } from "react";
import { HomeContext } from "../Context/ContextHome";
import { apiSae } from "../services/api";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { AdminContext } from "../Context/ContextAdmin";
import { yupResolver } from "@hookform/resolvers/yup";
import { UpdateEstacaoStyled, UpdatePocoStyled } from "../Styles/update";
import { IoClose } from "react-icons/io5";
import { ModalsConfirmeStyled } from "../Styles/Modals";
import helicoidal from "../Assets/Icons/helicoidal.svg";
import vertical from "../Assets/Icons/deslocamentoVertical.svg";
import submersivel from "../Assets/Icons/submersivel.svg";

export const ComponentUpdateEstacao = ({ onChangeFormSujo }) => {
  const {
    listarGeral,
    aoEditarDadosEstacao,
    componenteCriaNovoPoco,
    setComponenteCriaNovoPoco,
  } = useContext(AdminContext);
  const { headerApi } = useContext(HomeContext);
  const [cidades, setCidades] = useState([]);
  const [carregando, setCarregando] = useState(true); // Para evitar execução antes da hora

  const FormSchema = yup.object().shape({
    cidade: yup.number().required("*Este campo é obrigatório"),
    nome_estacao: yup.string().required("*Este campo é obrigatório"),
    tipo: yup.string().required("*Este campo é obrigatório"),
    codigo: yup.string().required("*Este campo é obrigatório"),
    possui_gerador: yup.boolean().required("*Este campo é obrigatório"),
    ativo: yup.boolean().required("*Este campo é obrigatório"),
    quantidadePocos: yup.number().required("*Este campo é obrigatório"),
  });

  const cidadesLista = async () => {
    try {
      const response = await apiSae.get("/cidades/LeituraTodos", headerApi);
      setCidades(response.data);
    } catch (error) {
      console.log(error);
    } finally {
      setCarregando(false);
    }
  };

  useEffect(() => {
    cidadesLista();
  }, []);

  const {
    register,
    handleSubmit,
    formState: { errors, isDirty },
    setValue,
    getValues,
  } = useForm({
    resolver: yupResolver(FormSchema),
    defaultValues: {
      cidade:
        typeof listarGeral.cidade === "object"
          ? listarGeral.cidade.id
          : listarGeral.cidade,
      nome_estacao: listarGeral.nome_estacao || "",
      tipo: listarGeral.tipo || "Elevatória",
      codigo: listarGeral.codigo || "",
      possui_gerador: !!listarGeral.possui_gerador,
      ativo: !!listarGeral.ativo,
      quantidadePocos: listarGeral.pocos?.length || 1,
    },
  });

  useEffect(() => {
    if (!carregando && cidades.length > 0 && listarGeral?.cidade) {
      // Verifique se listarGeral.cidade é um objeto ou um valor numérico
      const cidadeId =
        typeof listarGeral.cidade === "object"
          ? listarGeral.cidade.id
          : listarGeral.cidade;

      const cidadeExiste = cidades.some(
        (cidade) => cidade.id === Number(cidadeId)
      );

      if (cidadeExiste) {
        setValue("cidade", Number(cidadeId));
      }
    }
  }, [carregando, listarGeral, cidades, setValue]);

  useEffect(() => {
    onChangeFormSujo?.(isDirty);
  }, [isDirty]);

  if (!listarGeral || carregando) {
    return null; // ou um spinner
  }

  return (
    <UpdateEstacaoStyled>
      {componenteCriaNovoPoco == true && <ComponenteCriaNovoPoco />}
      <form onSubmit={handleSubmit(aoEditarDadosEstacao)}>
        <h3>Editar Estação</h3>

        <div className="editEstacao">
          <div className="divSeletores">
            <div className="seletores">
              <label>Cidade:</label>
              {!carregando && cidades.length > 0 && (
                <select {...register("cidade")} disabled={carregando}>
                  {cidades.map((cidade) => (
                    <option key={cidade.id} value={cidade.id}>
                      {cidade.nome_cidade}
                    </option>
                  ))}
                </select>
              )}
              {errors.cidade && <p>{errors.cidade.message}</p>}
            </div>

            <div className="seletores">
              <label>Tipo de Estação:</label>
              <select {...register("tipo")}>
                <option value="Elevatória">Elevatória</option>
              </select>
              {errors.tipo && <p>{errors.tipo.message}</p>}
            </div>

            <div className="updatePocos">
              <div className="qtdPoco">
                <label>Qtd. de Poços:</label>
                <select {...register("quantidadePocos")}>
                  <option value={1}>1</option>
                  <option value={2}>2</option>
                </select>
              </div>

              <button
                type="button"
                className={
                  listarGeral.pocos.length == 2
                    ? "NovoPocoDesativado"
                    : "criarNovoPoco"
                }
                onClick={() => setComponenteCriaNovoPoco(true)}
              >
                Adicionar Poço
              </button>
            </div>
          </div>

          <div className="divInputs">
            <div className="inputs">
              <label>Nome da Estação:</label>
              <input
                placeholder="Digite o nome da Estação"
                type="text"
                {...register("nome_estacao")}
              />
              {errors.nome_estacao && <p>{errors.nome_estacao.message}</p>}
            </div>

            <div className="inputs">
              <label>Codigo da Estação:</label>
              <input
                placeholder="Digite o Codigo Sigla da Estação"
                type="text"
                {...register("codigo")}
              />
              {errors.codigo && <p>{errors.codigo.message}</p>}
            </div>

            <div className="divCheck">
              <div className="check">
                <input
                  type="checkbox"
                  {...register("possui_gerador", {
                    valueAsNumber: true,
                    setValueAs: (value) => value || false,
                  })}
                />
                <label>Possui Gerador</label>
              </div>

              <div className="check">
                <input
                  type="checkbox"
                  {...register("ativo", {
                    valueAsNumber: true,
                    setValueAs: (value) => value || false,
                  })}
                />
                <label>Unidade Ativa</label>
              </div>
            </div>
          </div>
        </div>

        <div className="btSalvar">
          <button type="submit" className="botao">
            Salvar
          </button>
        </div>
      </form>
    </UpdateEstacaoStyled>
  );
};

export const ComponentUpdatePoco1 = ({ onChangeFormSujo }) => {
  const { listarGeral, aoEditarDadosPoco1, setComponenteEstacao } =
    useContext(AdminContext);

  const FormSchema = yup.object().shape({
    altura_poco: yup
      .number()
      .nullable("*Este campo é obrigatório")
      .typeError("*Este campo deve ser um número")
      .required("*Este campo é obrigatório"),
    altura_util_poco: yup
      .number()
      .nullable()
      .typeError("*Este campo deve ser um número")
      .required("*Este campo é obrigatório"),
    nivel_minimo: yup
      .number()
      .nullable()
      .typeError("*Este campo deve ser um número")
      .required("*Este campo é obrigatório"),

    nivel_maximo: yup
      .number()
      .nullable()
      .typeError("*Este campo deve ser um número")
      .required("*Este campo é obrigatório"),

    quantidade_bombas: yup
      .number()
      .nullable()
      .typeError("*Este campo deve ser um número")
      .required("*Este campo é obrigatório"),
    cesta: yup.boolean().required("*Este campo é obrigatório"),
    gtw_poco: yup
      .number()
      .nullable()
      .typeError("*Este campo deve ser um número"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors, isDirty },
    setValue,
    getValues,
    reset,
  } = useForm({
    resolver: yupResolver(FormSchema),
    defaultValues: {
      altura_poco: 0,
      nivel_minimo: 0,
      altura_util_poco: 0,
      nivel_maximo: 0,
      quantidade_bombas: 1,
      cesta: false,
      gtw_poco: 0,
    },
  });

  useEffect(() => {
    if (listarGeral.pocos?.[0]) {
      reset({
        altura_poco: listarGeral.pocos[0].altura_poco || 0,
        nivel_minimo: listarGeral.pocos[0].nivel_minimo || 0,
        altura_util_poco: listarGeral.pocos[0].altura_util_poco || 0,
        nivel_maximo: listarGeral.pocos[0].nivel_maximo || 0,
        quantidade_bombas: listarGeral.pocos[0].quantidade_bombas || 1,
        cesta: !!listarGeral.pocos[0].cesta,
        gtw_poco: listarGeral.pocos[0].gtw_poco || 0,
      });
    }
  }, [listarGeral.pocos, reset]);

  useEffect(() => {
    onChangeFormSujo?.(isDirty);
  }, [isDirty]);

  if (!listarGeral.pocos || listarGeral.pocos.length === 0) {
    return <p>Carregando dados...</p>;
  }

  return (
    <UpdateEstacaoStyled>
      <form onSubmit={handleSubmit(aoEditarDadosPoco1)}>
        <h3>Editar Poço</h3>

        <div className="editEstacao">
          <div className="divInputsPoco">
            <div className="inputs">
              <label>Altura do Poço:</label>
              <input
                placeholder="Altura do Poço"
                type="number"
                {...register("altura_poco")}
              ></input>
              {errors.altura_poco && <p>{errors.altura_poco.message}</p>}
            </div>

            <div className="inputs">
              <label>Nível Mínimo do Poço:</label>
              <input
                placeholder="Nível Mínimo"
                type="number"
                step="any"
                {...register("nivel_minimo")}
              ></input>
              {errors.nivel_minimo && <p>{errors.nivel_minimo.message}</p>}
            </div>

            <div className="inputs">
              <label>Altura Útil do Poço:</label>
              <input
                placeholder="Altura Útil"
                type="number"
                step="any"
                {...register("altura_util_poco")}
              ></input>
              {errors.altura_util_poco && (
                <p>{errors.altura_util_poco.message}</p>
              )}
            </div>
          </div>

          <div className="divSeletoresPoco">
            <div className="inputs">
              <label>Nível Máximo do Poço:</label>
              <input
                placeholder="Nível Máximo"
                type="number"
                step="any"
                {...register("nivel_maximo")}
              ></input>
              {errors.nivel_maximo && <p>{errors.nivel_maximo.message}</p>}
            </div>

            <div className="seletoresPoco">
              <label>Qtd de Bombas:</label>
              <select {...register("quantidade_bombas")}>
                <option value={1}>1</option>
                <option value={2}>2</option>
                <option value={3}>3</option>
              </select>
            </div>

            <div className="gtwCheck">
              <div className="inputs">
                <label>Gateway:</label>
                <input
                  placeholder="Nº. Gateway"
                  type="number"
                  step="any"
                  {...register("gtw_poco")}
                ></input>
                {errors.gtw_poco && <p>{errors.gtw_poco.message}</p>}
              </div>

              <div className="divCheck">
                <div className="check">
                  <input
                    className="inputCheck"
                    type="checkbox"
                    {...register("cesta", {
                      valueAsNumber: true,
                      setValueAs: (value) => value || false,
                    })}
                  ></input>
                  <label>Possui Cesta</label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="btSalvar">
          {listarGeral.pocos.length >= 2 && (
            <>
              <button className="botao btPoco" disabled={true}>
                Poço 1
              </button>

              <button
                className="botao"
                onClick={() => setComponenteEstacao("Poco2")}
              >
                Poço 2
              </button>
            </>
          )}

          <button
            type="submit"
            className="botao"
            onClick={() => setComponenteEstacao("Poco1")}
          >
            Salvar
          </button>
        </div>
      </form>
    </UpdateEstacaoStyled>
  );
};

export const ComponentUpdateBombasPoco1 = ({ onChangeFormSujo }) => {
  const { listarGeral, aoEditarDadosBombasPoco1, idBombas, setIdBombas } =
    useContext(AdminContext);

  const [imagensBombas, setImagensBombas] = useState([]);

  const handleSelectChange = (event, index) => {
    const selectedOption = event.target.value;
    const novaImagem =
      selectedOption === "helicoidal"
        ? helicoidal
        : selectedOption === "vertical"
        ? vertical
        : selectedOption === "submersivel"
        ? submersivel
        : null;

    setImagensBombas((prev) => {
      const novasImagens = [...prev];
      novasImagens[index] = novaImagem;
      return novasImagens;
    });
  };

  const FormSchema = yup.object().shape({
    bombas: yup.array().of(
      yup.object().shape({
        tipo_bomba: yup.string().required("*Este campo é obrigatório"),
        nivel_acionamento: yup
          .number()
          .nullable("*Este campo é obrigatório")
          .typeError("*Este campo deve ser um número")
          .required("*Este campo é obrigatório"),
        nivel_desligamento: yup
          .number()
          .nullable("*Este campo é obrigatório")
          .typeError("*Este campo deve ser um número")
          .required("*Este campo é obrigatório"),
      })
    ),
  });

  const {
    register,
    handleSubmit,
    formState: { errors, isDirty },
    setValue,
    getValues,
    reset,
  } = useForm({
    resolver: yupResolver(FormSchema),
    defaultValues: {
      bombas: [],
    },
  });

  const bombasAtuais = (() => {
    if (idBombas === "Poco2" && listarGeral?.pocos?.[1]?.bombas) {
      return listarGeral.pocos[1].bombas;
    }
    return listarGeral?.pocos?.[0]?.bombas || [];
  })();

  useEffect(() => {
    if (bombasAtuais && bombasAtuais.length > 0) {
      const valoresIniciais = bombasAtuais.map((bomba) => ({
        tipo_bomba: bomba.tipo_bomba || "",
        nivel_acionamento: bomba.nivel_acionamento || 0,
        nivel_desligamento: bomba.nivel_desligamento || 0,
      }));
      reset({ bombas: valoresIniciais });
    }
  }, [bombasAtuais]);

  useEffect(() => {
    if (listarGeral?.pocos?.length === 1 && idBombas !== "Poco1") {
      setIdBombas("Poco1");
    }
  }, [listarGeral, idBombas]);

  // useEffect(() => {
  //   const tipo = bombasAtuais?.[0]?.tipo_bomba;
  //   if (tipo === "helicoidal") {
  //     setImgBomba(helicoidal);
  //   } else if (tipo === "vertical") {
  //     setImgBomba(vertical);
  //   } else if (tipo === "submersivel") {
  //     setImgBomba(submersivel);
  //   }
  // }, [bombasAtuais]);

  useEffect(() => {
    if (bombasAtuais && bombasAtuais.length > 0) {
      const novasImagens = bombasAtuais.map((bomba) => {
        if (bomba.tipo_bomba === "helicoidal") return helicoidal;
        if (bomba.tipo_bomba === "vertical") return vertical;
        if (bomba.tipo_bomba === "submersivel") return submersivel;
        return null;
      });
      setImagensBombas(novasImagens);
    }
  }, [bombasAtuais]);

  useEffect(() => {
    onChangeFormSujo?.(isDirty);
  }, [isDirty]);

  if (!bombasAtuais || !Array.isArray(bombasAtuais)) {
    return <p>Sem bombas cadastradas neste poço.</p>;
  }

  return (
    <UpdateEstacaoStyled>
      <div>
        <h3>Editar Bombas do {idBombas === "Poco2" ? "Poço 2" : "Poço 1"}</h3>

        {bombasAtuais.map((bomba, index) => (
          <form
            className="blocoBomba"
            key={bomba.id || index}
            onSubmit={handleSubmit(async (data) => {
              await aoEditarDadosBombasPoco1(data);
            })}
          >
            <div className="editBomba">
              <div className="tituloBombas">
                <h2>Bomba {idBombas === "Poco2" ? "Poço 2" : "Poço 1"}</h2>
              </div>
              <div className="cadBomba">
                <div className="divSeletores">
                  <div className="seletores">
                    <label>Modelo de Bomba:</label>
                    <select
                      {...register(`bombas[${index}].tipo_bomba`)}
                      onChange={(event) => handleSelectChange(event, index)}
                    >
                      <option value="" disabled hidden>
                        Seleciona um modelo
                      </option>
                      <option value={"helicoidal"}>Helicoidal</option>
                      <option value={"vertical"}>Deslocamento Vertical</option>
                      <option value={"submersivel"}>Submersível</option>
                    </select>
                    {errors.bombas?.[index]?.tipo_bomba && (
                      <p>{errors.bombas[index].tipo_bomba.message}</p>
                    )}
                  </div>

                  <div className="seletores">
                    <label>Nível de Acionamento:</label>
                    <input
                      type="number"
                      step="any"
                      {...register(`bombas[${index}].nivel_acionamento`)}
                    />
                    {errors.bombas?.[index]?.nivel_acionamento && (
                      <p>{errors.bombas[index].nivel_acionamento.message}</p>
                    )}
                  </div>

                  <div className="seletores">
                    <label>Nível de Desligamento:</label>
                    <input
                      type="number"
                      step="any"
                      {...register(`bombas[${index}].nivel_desligamento`)}
                    />
                    {errors.bombas?.[index]?.nivel_desligamento && (
                      <p>{errors.bombas[index].nivel_desligamento.message}</p>
                    )}
                  </div>
                </div>
                <div className="divSeletores">
                  <div className="imgBomba">
                    <img src={imagensBombas[index]} alt="Imagem Bomba" />
                  </div>
                </div>
              </div>
            </div>

            <div className="btSalvar">
              {/* Botões de troca entre poços */}
              {listarGeral?.pocos?.length === 2 && (
                <>
                  <button
                    className="botao"
                    onClick={() => setIdBombas("Poco1")}
                    disabled={idBombas !== "Poco2"}
                  >
                    Bombas do Poço 1
                  </button>
                  <button
                    className="botao"
                    onClick={() => setIdBombas("Poco2")}
                    disabled={idBombas === "Poco2"}
                  >
                    Bombas do Poço 2
                  </button>
                </>
              )}

              <button className="botao" type="submit">
                Salvar
              </button>
            </div>
          </form>
        ))}
      </div>
    </UpdateEstacaoStyled>
  );
};

export const ComponentUpdatePoco2 = () => {
  const {
    listarGeral,
    aoEditarDadosPoco1,
    componenteEstacao,
    setComponenteEstacao,
  } = useContext(AdminContext);

  const FormSchema = yup.object().shape({
    altura_poco: yup
      .number()
      .nullable("*Este campo é obrigatório")
      .typeError("*Este campo deve ser um número")
      .required("*Este campo é obrigatório"),
    altura_util_poco: yup
      .number()
      .nullable()
      .typeError("*Este campo deve ser um número")
      .required("*Este campo é obrigatório"),
    nivel_minimo: yup
      .number()
      .nullable()
      .typeError("*Este campo deve ser um número")
      .required("*Este campo é obrigatório"),

    nivel_maximo: yup
      .number()
      .nullable()
      .typeError("*Este campo deve ser um número")
      .required("*Este campo é obrigatório"),

    quantidade_bombas: yup
      .number()
      .nullable()
      .typeError("*Este campo deve ser um número")
      .required("*Este campo é obrigatório"),
    cesta: yup.boolean().required("*Este campo é obrigatório"),
    gtw_poco: yup
      .number()
      .nullable()
      .typeError("*Este campo deve ser um número"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm({
    resolver: yupResolver(FormSchema),
  });

  if (!listarGeral.pocos || listarGeral.pocos.length === 0) {
    return <p>Carregando dados...</p>;
  }

  return (
    <UpdateEstacaoStyled>
      <form onSubmit={handleSubmit(aoEditarDadosPoco1)}>
        <h3>Editar Poço 2</h3>

        <div className="editEstacao">
          <div className="divInputsPoco">
            <div className="inputs">
              <label>Altura do Poço:</label>
              <input
                placeholder="Altura do Poço"
                type="number"
                defaultValue={listarGeral.pocos?.[1]?.altura_poco}
                {...register("altura_poco")}
              ></input>
              {errors.altura_poco && <p>{errors.altura_poco.message}</p>}
            </div>

            <div className="inputs">
              <label>Nível Mínimo do Poço:</label>
              <input
                placeholder="Nível Mínimo"
                type="number"
                step="any"
                defaultValue={listarGeral.pocos?.[1]?.nivel_minimo}
                {...register("nivel_minimo")}
              ></input>
              {errors.nivel_minimo && <p>{errors.nivel_minimo.message}</p>}
            </div>

            <div className="inputs">
              <label>Altura Útil do Poço:</label>
              <input
                placeholder="Altura Útil"
                type="number"
                step="any"
                defaultValue={listarGeral.pocos?.[1]?.altura_util_poco}
                {...register("altura_util_poco")}
              ></input>
              {errors.altura_util_poco && (
                <p>{errors.altura_util_poco.message}</p>
              )}
            </div>
          </div>

          <div className="divSeletoresPoco">
            <div className="inputs">
              <label>Nível Máximo do Poço:</label>
              <input
                placeholder="Nível Máximo"
                type="number"
                step="any"
                defaultValue={listarGeral.pocos?.[1]?.nivel_maximo}
                {...register("nivel_maximo")}
              ></input>
              {errors.nivel_maximo && <p>{errors.nivel_maximo.message}</p>}
            </div>

            <div className="seletoresPoco">
              <label>Qtd de Bombas:</label>
              <select
                // defaultValue={pocoOrdenada[0].bombas.length}
                defaultValue={listarGeral.pocos?.[1]?.quantidade_bombas}
                {...register("quantidade_bombas")}
              >
                <option value={1}>1</option>
                <option value={2}>2</option>
                <option value={3}>3</option>
              </select>
            </div>

            <div className="gtwCheck">
              <div className="inputs">
                <label>Gateway:</label>
                <input
                  placeholder="Nº. Gateway"
                  type="number"
                  step="any"
                  defaultValue={listarGeral.pocos?.[1]?.gtw_poco}
                  {...register("gtw_poco")}
                ></input>
                {errors.gtw_poco && <p>{errors.gtw_poco.message}</p>}
              </div>

              <div className="divCheck">
                <div className="check">
                  <input
                    className="inputCheck"
                    type="checkbox"
                    defaultChecked={listarGeral.pocos?.[0].cesta}
                    {...register("cesta", {
                      valueAsNumber: true,
                      setValueAs: (value) => value || false,
                    })}
                  ></input>
                  <label>Possui Cesta</label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="btSalvar">
          {listarGeral.pocos.length >= 2 && (
            <>
              <button
                className="botao"
                onClick={() => setComponenteEstacao("Poco1")}
              >
                Poço 1
              </button>

              <button className="botao btPoco" disabled={true}>
                Poço 2
              </button>
            </>
          )}
          <button
            type="submit"
            className="botao"
            onClick={() => setComponenteEstacao("Poco2")}
          >
            Salvar
          </button>
        </div>
      </form>
    </UpdateEstacaoStyled>
  );
};

export const ComponentUpdateBombasPoco2 = () => {
  return (
    <UpdateEstacaoStyled>
      <div>
        <h2>Bombas Poco2</h2>
      </div>
    </UpdateEstacaoStyled>
  );
};

export const ComponenteCriaNovoPoco = () => {
  const {
    listarGeral,
    componenteCriaNovoPoco,
    setComponenteCriaNovoPoco,
    createEstacao,
    setCreateEstacao,
    aoCriarNovoPoco,
  } = useContext(AdminContext);

  const FormSchema = yup.object().shape({
    nome_estacao: yup.string().required("*Este campo é obrigatório"),

    altura_poco: yup
      .number()
      .nullable("*Este campo é obrigatório")
      .typeError("*Este campo deve ser um númeroP1")
      .required("*Este campo é obrigatório"),
    altura_util_poco: yup
      .number()
      .nullable()
      .typeError("*Este campo deve ser um número")
      .required("*Este campo é obrigatório"),
    nivel_minimo: yup
      .number()
      .nullable()
      .typeError("*Este campo deve ser um número")
      .required("*Este campo é obrigatório"),
    nivel_maximo: yup
      .number()
      .nullable()
      .typeError("*Este campo deve ser um número")
      .required("*Este campo é obrigatório"),

    quantidade_bombas: yup
      .number()
      .nullable()
      .typeError("*Este campo deve ser um número")
      .required("*Este campo é obrigatório"),
    cesta: yup.boolean().required("*Este campo é obrigatório"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm({
    resolver: yupResolver(FormSchema),
  });

  return (
    <UpdatePocoStyled>
      <div className="novoPoco">
        <form onSubmit={handleSubmit(aoCriarNovoPoco)}>
          <div className="titulo">
            <h3>Cadastrar Novo Poço</h3>
            <span
              className="fechaModal"
              onClick={() => {
                setComponenteCriaNovoPoco(false);
              }}
            >
              <IoClose />
            </span>
          </div>

          <div className="editNovoPoco">
            <div className="">
              <label>Nome da Estação:</label>
              <input
                placeholder="Digite o nome da Estação"
                type="text"
                defaultValue={listarGeral.nome_estacao}
                {...register("nome_estacao")}
              />
              {errors.nome_estacao && <p>{errors.nome_estacao.message}</p>}
            </div>

            <div className="seletores">
              <label>Altura do Poço:</label>
              <input
                defaultValue={createEstacao[1]?.altura_poco ?? ""}
                placeholder="Altura do Poço"
                type="number"
                step="any"
                {...register("altura_poco")}
              ></input>
              {errors.altura_poco && <p>{errors.altura_poco.message}</p>}
            </div>

            <div className="seletores">
              <label>Nível Mínimo do Poço:</label>
              <input
                defaultValue={createEstacao[1]?.nivel_minimo ?? ""}
                placeholder="Nível Mínimo"
                type="number"
                step="any"
                {...register("nivel_minimo")}
              ></input>
              {errors.nivel_minimo && <p>{errors.nivel_minimo.message}</p>}
            </div>

            <div className="seletores">
              <label>Altura Útil do Poço:</label>
              <input
                defaultValue={createEstacao[1]?.altura_util_poco ?? ""}
                placeholder="Altura Útil"
                type="number"
                step="any"
                {...register("altura_util_poco")}
              ></input>
              {errors.altura_util_poco && (
                <p>{errors.altura_util_poco.message}</p>
              )}
            </div>

            <div className="seletores">
              <label>Nível Máximo do Poço:</label>
              <input
                defaultValue={createEstacao[1]?.nivel_maximo ?? ""}
                placeholder="Nível Máximo"
                type="number"
                step="any"
                {...register("nivel_maximo")}
              ></input>
              {errors.nivel_maximo && <p>{errors.nivel_maximo.message}</p>}
            </div>

            <div className="seletores">
              <label>Qtd de Bombas:</label>
              <select
                {...register("quantidade_bombas")}
                defaultValue={createEstacao[1]?.quantidade_bombas ?? ""}
              >
                <option value={1}>1</option>
                <option value={2}>2</option>
                <option value={3}>3</option>
              </select>
            </div>

            <div className="check">
              <input
                defaultChecked={createEstacao[1]?.cesta ?? ""}
                type="checkbox"
                {...register("cesta", {
                  valueAsNumber: true,
                  setValueAs: (value) => value || false,
                })}
              ></input>
              <label>Possui Cesta</label>
            </div>

            <div className="btSalvar">
              <button className="botao" type="submit">
                Salvar
              </button>
            </div>
          </div>
        </form>
      </div>
    </UpdatePocoStyled>
  );
};

export const ConfirmaUpdate = ({ onConfirm, onCancel }) => {
  return (
    <ModalsConfirmeStyled>
      <div className="blocoConfirma">
        <h3>
          Você possui alterações não salvas. Deseja salvar antes de continuar?
        </h3>
        <div className="botao">
          <button onClick={onConfirm}>Sim</button>
          <button className="botaoNao" onClick={onCancel}>
            Não
          </button>
        </div>
      </div>
    </ModalsConfirmeStyled>
  );
};
